export const themeOverrides = {
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        #root {
          display: flex;
          flex-direction: column;
          flex-wrap: nowrap;
          height: 100%;
          min-height: 100%;
          overflow-x: hidden;
          user-select: none;
          width: 100%;
        }

        .casinoexe-body--desktop > #root {
		      min-height: 720px;
          min-width: 1180px;
          overflow-y: hidden;
          position: relative;
        }

        .casinoexe-body--mobile > #root {
          background-position-x: left;
          background-position-y: center;
          background-repeat: no-repeat;
          background-size: cover;
          background-image: url(/assets/casinoexe/img/background.jpg);
        }

        .casinoexe-body--desktop .game-modal-portal-live .ReactModal__Content {
          background: #424242;
        }

        .user-block {
          padding-left: 4px;
          padding-right: 4px;
          flex: 1 0 auto;

          @media screen and (orientation: landscape) {
            max-width: 180px;          
          }
        }

        .user-block__value {
          font-weight: bold;
        }
      `,
    },
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: "rgb(0 0 0)"
        }
      }
    },
  },
  typography: {
    muted: {
      opacity: '.6',
    },
  },
  palette: {
    mode: 'dark',
    primary: {
      main: '#f7f3a3',
    },
    secondary: {
      main: '#cacaca',
    },
    toolbar: {
      main: '#ffffff',
    }
  },
}
